import script from "./PaymentSlipUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentSlipUpload.vue?vue&type=script&setup=true&lang=js"

import "./PaymentSlipUpload.vue?vue&type=style&index=0&id=6f7e7946&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f7e7946"]])

export default __exports__